const type = 'STOP_CUSTOMER_BY_CARDS_FETCHING';

const stopCustomersByCardsFetching = () => ({
  type,
});

export { type };
export default stopCustomersByCardsFetching;
